import { useEffect, useState } from "react";

import { updatePaymentSettings } from "../../services/settingsApi";

function PaymentSettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        razorpayKey: "",
        razorpaySecret: "",
        stripeKey: "",
        stripeSecret: "",
        codEnabled: false,
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                razorpayKey: settings.razorpayKey || "",
                razorpaySecret: settings.razorpaySecret || "",
                stripeKey: settings.stripeKey || "",
                stripeSecret: settings.stripeSecret || "",
                codEnabled: settings.codEnabled || false,
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updatePaymentSettings(formData);

            alert("Payment settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update payment settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>Payment Gateway Settings</h2>

                <div className="settings-grid">

                    <div className="form-group">

                        <label>Razorpay Key</label>

                        <input
                            type="text"
                            name="razorpayKey"
                            value={formData.razorpayKey}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Razorpay Secret</label>

                        <input
                            type="password"
                            name="razorpaySecret"
                            value={formData.razorpaySecret}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Stripe Publishable Key</label>

                        <input
                            type="text"
                            name="stripeKey"
                            value={formData.stripeKey}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Stripe Secret Key</label>

                        <input
                            type="password"
                            name="stripeSecret"
                            value={formData.stripeSecret}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group checkbox-group">

                        <label>

                            <input
                                type="checkbox"
                                name="codEnabled"
                                checked={formData.codEnabled}
                                onChange={handleChange}
                            />

                            Enable Cash on Delivery

                        </label>

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save Payment Settings
                </button>

            </div>

        </form>

    );

}

export default PaymentSettings;